import { render, staticRenderFns } from "./AdminSIMCards.vue?vue&type=template&id=6fd532b1&scoped=true&"
import script from "./AdminSIMCards.vue?vue&type=script&lang=js&"
export * from "./AdminSIMCards.vue?vue&type=script&lang=js&"
import style0 from "./AdminSIMCards.vue?vue&type=style&index=0&id=6fd532b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd532b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fd532b1')) {
      api.createRecord('6fd532b1', component.options)
    } else {
      api.reload('6fd532b1', component.options)
    }
    module.hot.accept("./AdminSIMCards.vue?vue&type=template&id=6fd532b1&scoped=true&", function () {
      api.rerender('6fd532b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminSIMCards.vue"
export default component.exports